module.exports = __webpack_public_path__ + "img/8H.a3d87fdd.svg";